import { prop } from 'ramda';
import { urls } from '../../config.js';
import getParams from '../../utils/getParams';
import { translateHugggPaginatedResponse } from '../../utils/huggg';
var allowedEmbeds = ['message', 'redeemed', 'voucher', 'receiver', 'voucher.segment', 'purchase', 'purchase.brand', 'purchase.segments', 'purchase.brand.stores', 'purchase.brand.integration'];

/**
 * Fetch all hugggs by a given transaction ID, with optional query parameters.
 * Data is translated into camelCase before being returned.
 *
 * Any embedded data is stripped before sending. Although the API endpoint does
 * support it, it returns too much data in this instance.
 *
 * huggg.allByTransactionId(axios, transactionId).then( ... )
 * huggg.allByTransactionId(transactionId).then( ... )
 * huggg.allByTransactionId(transactionId, {page: 2, perPage: 40}).then( ... )
 *
 * @param {Object} [axios=axios] Axios instance.
 * @param {String} transactionId ID for transaction to fetch.
 * @param {Object} [options={}] Query string parameter options.
 * @param {Number} [options.page=1] Which page of data to fetch.
 * @param {Number} [options.perPage=20] How many results per page to fetch.
 * @returns {Promise} Unresolved promise.
 * @throws {Error} If no transactionId is supplied.
 */
var allByTransactionId = function allByTransactionId(axios, transactionId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!transactionId) {
    throw new Error('Prop `transactionId` is required in `huggg.allByTransactionId`');
  }
  if (options.embed && Array.isArray(options.embed)) {
    options.embed = options.embed.filter(function (embedded) {
      return allowedEmbeds.includes(embedded);
    });
  } else {
    delete options.embed;
  }
  var defaultParams = {
    per_page: 20,
    page: 1
  };
  var params = getParams(options, defaultParams, {
    sortColumnMap: {
      expires: 'expires',
      status: 'status'
    }
  });
  return axios.get(urls.apiV2("/transactions/".concat(transactionId, "/hugggs")), {
    params: params
  }).then(prop('data')).then(translateHugggPaginatedResponse);
};
export default allByTransactionId;